import { Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import { useUserData } from 'hooks/use-user-data';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import PaiButton from '../ui/base-components/pai-button';

interface Props {
  open: boolean;

  handleClose(): void;
}

const ContactPartnerDialog: React.FC<Props> = ({ open, handleClose }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { firstName } = useUserData();

  const contactPartner = () => {
    window.open('mailto:lead@a47-consulting-team.de', '_blank');
  };

  return (
    <Dialog classes={{ paper: classes.paper }} open={open} fullWidth={true} maxWidth={'xs'}>
      <DialogContent className={classes.content}>
        <Typography className={classes.title}>{t('contactPartnerTitle', { firstName })}</Typography>
        <Typography className={classes.text}>{t('contactPartnerText')}</Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('cancel')} size={'sm'} underline={'always'} action={handleClose} />
        <PaiButton text={t('contactPartner')} action={contactPartner} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 0,
  },
  content: {
    padding: '20px 24px !important',
  },
  title: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 'bold',
    whiteSpace: 'pre-wrap',
    marginBottom: '16px',
  },
  text: {
    fontSize: theme.typography.pxToRem(13),
    whiteSpace: 'pre-wrap',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default ContactPartnerDialog;
